var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-video__wrapper"},[_c('div',{ref:"CI_Video",staticClass:"product-video"})])
}
var staticRenderFns = []

export { render, staticRenderFns }